import styled, { css } from "styled-components";
import { ThemeType, ThemeTypeList } from "../../constants/theme";
import { transition } from "project-config/style";

export const getButtonStyle = (p: ThemeType) => {
  if (!p.themeType)
    return {
      common: css``,
      primary: css``,
    };
  return {
    [ThemeTypeList.TASK_EVA]: {
      common: css``,
      primary: css``,
    },
    [ThemeTypeList.USER_CENTER]: {
      common: css`
        min-width: max-content;
        transition: ${transition("background")};
      `,
      default: css`
        background: #464d56;
        border-color: transparent;
        &:hover {
          background: #1a1c1f;
          border-color: transparent;
          color: var(--main-color);
        }
        &:active {
          background: #1a1c1f;
          border-color: transparent;
          color: #078a4c;
        }
        &[disabled],
        &[disabled]:hover {
          background: #33373f;
          border-color: transparent;
          color: #6c767f;
        }
      `,
      primary: css`
        background: var(--main-color);
        border-color: var(--main-color);
        &:hover {
          background: var(--main-color-btn-hover-center);
          border-color: var(--main-color-btn-hover-center);
        }
        &:active {
          background: var(--main-color-btn-active);
          border-color: transparent;
        }
        &[disabled],
        &[disabled]:hover {
          background: var(--main-color-btn-disable);
          border-color: var(--main-color-btn-disable);
        }
      `,
    },
  }[p.themeType];
};
